Namespace 'Customer'

class Customer.ReactionsClient
  constructor: (interaction) ->
    @baseUrl = '/customer/dashboard'
    @interaction = interaction

  react: (socialAccountId) ->
    params = @_defaultParams(socialAccountId)
    params['reaction_type'] = 'love'
    @_post("#{@baseUrl}/react", params, 'interaction:react')

  unreact: (socialAccountId) ->
    params = @_defaultParams(socialAccountId)
    params['reaction_type'] = 'love'
    @_post("#{@baseUrl}/unreact", params, 'interaction:unreact')

  _defaultParams: (socialAccountId) ->
    {
      interaction_id: @interaction.get('interactionId'),
      social_account_id: socialAccountId,
      conversation_id: @interaction.get('conversation').get('id')
    }

  _post: (url, params, eventName) ->
    $.ajax(
      type: 'POST'
      url: url
      data: params
      success: => @interaction.trigger(eventName)
      error: (response) => @_handleError(response)
    )

  _handleError: (response) ->
    responseText = JSON.parse(response.responseText)
    react_error = @_getTranslation('react_error')
    switch responseText.reaction_error_code
      when 'InstagramSendPrivateMessageError'
        errorDetails = responseText.reaction_error_data
        showError("#{react_error} - #{errorDetails.message}")
      when 'MessageOutsideAllowedWindowError'
        text = @_getTranslation('reaction_outside_allowed_window_error')
        swal({title: '', text: text, type: 'error', showConfirmButton: false})
      when 'FacebookApiInternalError'
        errorDetails = responseText.reaction_error_data
        react_error = @_getTranslation('facebook_api_error', {
          errorCode: errorDetails.code,
          errorMessage: errorDetails.message
        })
        showError(react_error)
      else showError(react_error)

  _getTranslation: (key, params = {}) ->
    I18n.t("customer.dashboard.conversations.interactions.#{key}", params)
